import { ReactNode, useEffect, useState } from "react";
import context, { RisersMode, Trapvorm } from "./index";

import { Material, OrderType, ProfileColor } from "../../types/orderTypes";
import useAxios from "../../hooks/axios/useAxios";
import { baseUrl } from "../../config/serverConfig";

/**
 * Houdt de configuratie van de trap vast. Geen enkel bedrag: prijzen komen uit
 * de backend (zie PricingContext).
 */
export default function CreateOrderProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [type, setType] = useState<OrderType>(OrderType.Open);
  const [profileColor, setProfileColor] = useState<ProfileColor>(
    ProfileColor.Aluminium
  );

  const [stairMaterial, setStairMaterial] = useState<Material>(Material.HPL);
  const [stairColor, setStairColor] = useState<string>("");
  const [stairAmount, setStairAmount] = useState<number>(0);
  const [breedte, setBreedte] = useState<number>(140);
  const [trapvorm, setTrapvorm] = useState<Trapvorm>("recht");

  const [risersMode, setRisersMode] = useState<RisersMode>("standaard");
  const [specialRiserId, setSpecialRiserId] = useState<string | null>(null);

  const [topConnectionCode, setTopConnectionCode] = useState<string>("");

  const [extrasLed, setExtrasLed] = useState<boolean>(false);
  const [ledMode, setLedMode] = useState<string>("");
  const [ledCustomText, setLedCustomText] = useState<string>("");
  const [ledDimmer, setLedDimmer] = useState<boolean>(false);
  const [ledSensor, setLedSensor] = useState<boolean>(false);

  const [extrasPlateau, setExtrasPlateau] = useState<boolean>(false);
  const [plateauMaterial, setPlateauMaterial] = useState<Material>(Material.HPL);
  const [plateauSize, setPlateauSize] = useState<string>("");

  const [margin, setMargin] = useState<number>(20);
  const [pvcCustomColor, setPvcCustomColor] = useState<boolean>(false);

  const [first_name, setFirst_name] = useState<string>("");
  const [last_name, setLast_name] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [street, setStreet] = useState<string>("");
  const [house_number, setHouse_number] = useState<string>("");
  const [zipcode, setZipcode] = useState<string>("");
  const [city, setCity] = useState<string>("");

  const { fetchData: fetchMyOffice } = useAxios({ method: "get" });

  // Marge start op de standaardmarge van het eigen kantoor (Instellingen →
  // "Standaard marge %"). Geen/ongeldig antwoord → fallback 20 blijft staan.
  // Clamp op het bereik van de marge-select (10-60%).
  useEffect(() => {
    (async () => {
      const res = await fetchMyOffice(`${baseUrl}/office/my-office`);
      const dm = Number(res?.data?.defaultMargin);
      if (!res?.error && Number.isFinite(dm) && dm > 0) {
        setMargin(Math.min(60, Math.max(10, Math.round(dm))));
      }
    })();
    // eslint-disable-next-line
  }, []);

  const value = {
    type: { value: type, set: setType },
    profileColor: { value: profileColor, set: setProfileColor },

    stairMaterial: { value: stairMaterial, set: setStairMaterial },
    stairColor: { value: stairColor, set: setStairColor },
    stairAmount: { value: stairAmount, set: setStairAmount },
    breedte: { value: breedte, set: setBreedte },
    trapvorm: { value: trapvorm, set: setTrapvorm },

    risersMode: { value: risersMode, set: setRisersMode },
    specialRiserId: { value: specialRiserId, set: setSpecialRiserId },

    topConnectionCode: { value: topConnectionCode, set: setTopConnectionCode },

    extrasLed: { value: extrasLed, set: setExtrasLed },
    ledMode: { value: ledMode, set: setLedMode },
    ledCustomText: { value: ledCustomText, set: setLedCustomText },
    ledDimmer: { value: ledDimmer, set: setLedDimmer },
    ledSensor: { value: ledSensor, set: setLedSensor },

    extrasPlateau: { value: extrasPlateau, set: setExtrasPlateau },
    plateauMaterial: { value: plateauMaterial, set: setPlateauMaterial },
    plateauSize: { value: plateauSize, set: setPlateauSize },

    margin: { value: margin, set: setMargin },
    pvcCustomColor: { value: pvcCustomColor, set: setPvcCustomColor },

    first_name: { value: first_name, set: setFirst_name },
    last_name: { value: last_name, set: setLast_name },
    email: { value: email, set: setEmail },
    phone: { value: phone, set: setPhone },
    street: { value: street, set: setStreet },
    house_number: { value: house_number, set: setHouse_number },
    zipcode: { value: zipcode, set: setZipcode },
    city: { value: city, set: setCity },
  };

  return <context.Provider value={value}>{children}</context.Provider>;
}
